export enum ResourceTypeEnum {
  TEXT = 1,
  VIDEO = 2,
  IMAGE = 3,
  QUIZ = 4,
  QUESTION = 5,
  ANSWER = 6,
  EVENT = 7,
  REMINDER = 8,
  SPEAKER = 9,
  INSCRIPTION = 10,
  ATTEND = 11,
  PARTICIPATION = 12,
  FAQ = 13,
  FAQ_1_CONTENT = 14,
  FAQ_2_CONTENT = 15,
  FAQ_3_CONTENT = 16,
  FAQ_4_CONTENT = 17,
  FAQ_5_CONTENT = 18,
  GALLERY = 19,
  GALLERY_IMAGE = 20,
  GALLERY_VIDEO = 21,
  CONTACT_MAIL = 22,
  MATERIAL = 23,
  SURVEY = 24,
  ACTIVATION_BUTTON = 25,
  SHOPPING_CART = 26,
  SHOPPING_CART_GROUP = 27,
  SHOPPING_CART_PRODUCT = 28,
  RESOURCES_GUIDE = 29,
  LINKED_CHALLENGES = 30,
  CHALLENGE_MATERIALS = 31,
  EXPERIENCE_PROGRESS = 32,
  REDEEM_PRODUCT = 33,
  CHECKOUT = 34,
  CHECKOUT_PRODUCT = 35,
  QUIZ_TYPEFORM = 36,
  USER_UPLOAD_MEDIA = 37,
  EXPERIENCE_ACTIVATION = 38,
  STEPS = 41,
  STEPS_CONTENT = 42,
  VIDEO_SECTION = 48,
  WYSIWYG = 49,
  TEXT_LINK = 52,
  TEXT_LINK_ITEM = 52,
  EMAIL_WITH_DELAY = 54,
  INCLUDED_ITEMS_LIST = 59,
  INCLUDED_ITEM = 60,
  EMAIL_WITH_DATE = 55,
  WYSWYG_PIN = 57,
  TEXT_DURATION = 58,
  CHECKOUT_LOTTERY = 61,
  DOCUMENT = 62,
  ARN_SURVEY = 63,
  ARN_SURVEY_TOKEN = 64,
  BEAUTY_GUIDE = 65,
  HIDDEN = 66,
  CHECKOUT_DONATION = 67,
  CHECKOUT_DONATION_POINTS = 68,
  CHECKOUT_SUPPLEMENTARY_PRODUCT = 69,
  WYSIWYG_CUSTOM_HEADBOARD = 70,
  QUIZ_DERMO = 72,
  QUIZ_DERMO_PARTICIPATION = 74,
  FORMATION_CERTIFICATE = 73,
  CHECKOUT_BOOKING_TIMIFY = 75,
  CHECKOUT_PAYMENT_GATEWAY = 80,
  CHECKOUT_PAYMENT_GATEWAY_PRODUCT = 81,
}

export enum ChallengedTabsEnum {
  ALL = 0,
  PENDING = 1,
  COMPLETED = 2,
  FAVORITES = 3,
  REGISTERED = 4,
  ATTENDED = 5,
  MY_FORMATION = 6,
  ACCREDITED_FORMATION = 7,
}

export enum IResourceBehaviorsEnum {
  DISABLED = 1,
  HIDDEN = 2,
}
